
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.188 7.39c-.605.49-1.211.735-1.82.735-.36 0-.662-.099-.907-.297-.24-.198-.482-.523-.727-.976L3.29 4.21a6.46 6.46 0 01-.922.617V8H1.023V2.656c0-.677-.041-1.11-.125-1.297C.815 1.167.536 1.03.062.945V.531l1.82-.086h.485v3.711c.584-.39 1.328-1.13 2.235-2.218.588-.72 1.02-1.16 1.296-1.32.282-.167.586-.25.915-.25.28 0 .541.04.78.124V1.97H6.97c-.12-.235-.305-.352-.555-.352-.219 0-.448.1-.687.297-.24.193-.727.69-1.461 1.492l1.875 3.14c.296.5.617.75.96.75.256 0 .516-.122.782-.366l.304.46z","fill":"currentColor"}})])
          )
        }
      }
    